// import MockWrapper from './mocks/mockWrapper';
import BannerWrapper from './components/bannerWrapper';

// new MockWrapper().onLoad();
new BannerWrapper().onLoad();
